export default __webpack_public_path__ + "static/media/hero_new.3523742d.jpg";